/**
 * 環境変数 NEXT_PUBLIC_CAMPAIGN_TYPE が 'MYNAVI' のときに true を返す。
 * ビルド時に決定されるため、実行時コストはほぼゼロ。
 */
export function isMynaviMode(): boolean {
  return process.env.NEXT_PUBLIC_CAMPAIGN_TYPE === 'MYNAVI'
}
